import React from 'react';
import { Link } from "react-router-dom";
import './ServiceListSection.css';

const ServiceListSection = () => {
  const servicesData = [
    {
      category: 'Engineering',
      services: [
        { name: 'PESO', description: 'Petroleum and Explosives Safety Organization approvals.', link: '/peso' },
        { name: 'Architectural Plans', description: 'Plans for buildings and factories.', link: '/architectural-design' },
      ],
    },
    {
      category: 'Licensing',
      services: [
        { name: 'PESO', description: 'PESO-related licensing.', link: '/peso' },

        { name: 'FC (Forest Clearance)', description: 'Obtain forest clearance permits.', link: '/forest-clearance' },
        { name: 'EC (Environment Clearance)', description: 'Environmental clearances for projects.', link: '/environmental-clearance' },
        { name: 'CTE', description: 'Consent to Establish certification.', link: '/consent-to-estalish' },
        { name: 'CTO', description: 'Consent to Operate certification.', link: '/consent-to-operate' },
        { name: 'Hazardous Waste', description: 'Handling hazardous waste approvals.', link: '/hazardous-waste-licensing' },
        { name: 'Bio-Medical Waste Authorization', description: 'Authorization for bio-medical waste management.', link: '/bio-medical-waste-authorization' },
        { name: 'Fire Licensing', description: 'Fire safety recommendation ,certification.', link: '/fire-licensing' },

        { name: 'Clinical Establishment', description: 'Licensing and certification for clinical establishments.', link: '/clinical-establishment-licensing' },
      ],
    },
    {
      category: 'NOCs',
      services: [
        { name: 'Fire NOC', description: 'Fire safety NOC approvals.', link: '/fire-nocs' },
        { name: 'CGWA NOC', description: 'Central Ground Water Authority approvals.', link: '/cgwanoc' },
        { name: 'Airport Height Clearance NOC', description: 'The Airport Authority of India (AAI) approvals.', link: '/airport-height-clearance-noc' },
        { name: 'WaterAllocationOrderNOC', description: 'Ensure sustainable water use and comply with legal requirements through expert water allocation order NOC assistance.', link: '/water-allocatio-norder-noc' },
        { name: 'VariousGovtOfficialsNOCs', description: 'Get assistance with obtaining necessary NOCs for smooth operations.', link: '/various-govt-officials-nocs' },
      ],
    },
    {
      category: 'Compliance and Audit',
      services: [
        { name: 'PESO Compliance', description: 'Ensure the safety, compliance, and smooth operations of your hazardous material handling facilities with our expert PESO services.', link: '/peso-compliance' },
        { name: 'Forest Clearance Compliance', description: 'Expert consultation for various approvals.', link: '/forest-clearance-compliance' },
        { name: 'Environmental Clearance Compliance', description: 'Expert guidance for obtaining environmental clearances and ensuring legal adherence.', link: '/environment-clearance-compliance' },
        { name: 'Consent to Operate (CTO) Compliance', description: 'Expert consultation for various approvals.', link: '/consent-to-operate-compliance' },
        { name: 'Central Ground Water Authority (CGWA) Compliance', description: 'Expert consultation for various approvals.', link: '/cgwa-compliance' },
      ],
    },
    {
      category: 'Miscellaneous',
      services: [
        { name: 'Feasibility Study for Construction', description: 'Evaluate the viability of your construction project with expert assistance.', link: '/feasibility-study-for-construction' },
        { name: 'Environmental Impact Assessment (EIA)', description: 'Ensure your project aligns with environmental regulations and promotes sustainability..', link: '/environment-impact-assesment' },
        { name: 'Tank Testing Certificate (Explosive)', description: 'Ensure the safety and compliance of tanks used for explosive materials with our expert services.', link: '/tank-testing-certificate' },
       

      ],
    },
  ];

  return (
    <section className="service-list-section">
      <h2 className="service-list-title">Our Professional Services</h2>
      <div className="service-categories">
        {servicesData.map((category, index) => (
          <div key={index} className="service-category">
            <h3 className="service-category-title">{category.category}</h3>
            <ul className="service-list">
              {category.services.map((service, idx) => (
                <li key={idx} className="service-item">
                  <h4>{service.name}</h4>
                  <p>{service.description}</p>
                  <Link to={service.link} className="service-link">Learn More</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServiceListSection;
